export default __webpack_public_path__ + "static/media/bluepin.05c1959c.svg";